import { createModel } from "hox";
import { useState, useEffect } from "react";
import { RepairHistoryDetail, RepairHistorySearch } from "./repairHistoryType";
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE, } from "@/utils/constants";
import { TablePaginationConfig } from "antd/es/table/interface";
import { transPgToPagination } from "@/utils/utils";
import { ISearchPage } from "@/types/ScmTypes";
import { repairHistoryService } from "./repairHistoryService";
import { sourceAppOrBranch } from "@/types/VrmSaDictEnums";
import useGlobalModel from "@/model/globalModel";
import { convertRes2Blob } from "@/utils/exportFile";

export const useRepairHistoryModel = createModel(function () {
    const { shopAndOrg, setLoadingInfo } = useGlobalModel(({ shopAndOrg }) => [shopAndOrg]);
    const [loading, setLoading] = useState<boolean>(false)
    const initSearchParam: RepairHistorySearch = {};
    const initDataSource: RepairHistoryDetail[] = [];
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    //查询条件
    const [searchParam, setSearchParam] = useState<RepairHistorySearch>(initSearchParam);
    //列表数据源
    const [dataSource, setDataSource] = useState<RepairHistoryDetail[]>(initDataSource);
    //列表数据源分页参数
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);

    useEffect(() => {
        setSearchParam(initSearchParam);
    }, [shopAndOrg.shopCode])


    const updateSearchParam = (updateParam: RepairHistorySearch) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }
    const resetSearchParam = () => {
        setSearchParam(initSearchParam);
        loadData(initPgCfg, {});
    }
    const reset = () => {
        setSearchParam(initSearchParam);
        loadData(initPgCfg, {});
    }

    const loadData = async (page?: ISearchPage, searchValue: RepairHistorySearch = searchParam) => {
        setLoading(true);
        const shopParam = {
            shopType: searchValue.shopId !== undefined ? 1 : shopAndOrg.shopType,
            shopId: searchValue.shopId ?? shopAndOrg.shopId,
            shopCode: shopAndOrg.shopCode,
            shopName: shopAndOrg.shopName
        };
        const searchParams = {
            ...searchValue,
            ...shopParam,
            ...sourceAppOrBranch,
            pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
            pageNum: (page?.pageNum || page?.current) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
        }
        let { retData } = await repairHistoryService.repairHistory(searchParams);
        setLoading(false);
        const { records, ...pg } = retData;
        setPgCfg(transPgToPagination(pg));
        setDataSource(records);
    }

    const repairHistoryExport = async (searchValue: RepairHistorySearch = searchParam) => {
        setLoadingInfo({ loadingVisible: true, txt: "快速导出中" })
        const shopParam = {
            shopType: searchValue.shopId !== undefined ? 1 : shopAndOrg.shopType,
            shopId: searchValue.shopId ?? shopAndOrg.shopId,
            shopCode: shopAndOrg.shopCode,
            shopName: shopAndOrg.shopName
        };
        const searchParams = {
            ...searchValue,
            ...shopParam,
        }
        try {
            let result = await repairHistoryService.repairHistoryExport(searchParams);
            result && setLoadingInfo({ loadingVisible: false, txt: "" });
            convertRes2Blob(result)
        } catch {
            setLoadingInfo({ loadingVisible: false, txt: "" });
        }

    }
    return {
        searchParam,
        dataSource,
        pgCfg,
        initPgCfg,
        setSearchParam,
        setDataSource,
        setPgCfg,
        updateSearchParam,
        resetSearchParam,
        loadData,
        loading, setLoading,
        reset,
        repairHistoryExport
    }
})